import _ from 'lodash';
import Image from 'next/image';

import { IconWithLabel } from '@/components/atomic/atoms';
import { staticMediaStoreBaseURL } from '@/config/common';
import { useIsMobile } from '@/lib/screenResolution';
import { PARTNER_TIER } from '@/services/home.service';

const ProfileHeaderOrganism = ({
  partnerDetails,
  partnerSummaryStats,
  partnerUser
}) => {
  const { emailId, legalNameOfPartnerOrg, mobileNumber } = partnerUser;
  const { partner: { address, coreCategories = [], pocName } = {} } =
    partnerDetails || {};
  const { partnerTier } = partnerSummaryStats;

  const eventTypes = coreCategories
    .map(({ name }) => name)
    .filter((value) => value)
    .join(', ');

  const [isMobile] = useIsMobile();

  const { icon, label, starIcon, valueStyle } = PARTNER_TIER[partnerTier];

  const iconwithLabelData = [
    {
      containerClass: 'flex gap-2',
      imgAlt: 'phone',
      imgSrc: 'call-white.svg',
      value: mobileNumber,
      valueStyle: 'text-sm md:text-base font-medium text-white self-center'
    },
    {
      containerClass: 'flex gap-2',
      imgAlt: 'email',
      imgSrc: 'email-icon.svg',
      value: emailId,
      valueStyle: 'text-sm md:text-base font-medium text-white self-center'
    },
    {
      containerClass: 'flex gap-2',
      imgAlt: 'event-types',
      imgSrc: 'event-types-white-icon.svg',
      value: eventTypes || 'N/A',
      valueStyle: 'text-sm md:text-base font-medium text-white self-center'
    },
    {
      containerClass: 'flex gap-2',
      imgAlt: 'address',
      imgSrc: 'location-white.svg',
      value: address ?? 'N/A',
      valueStyle: 'text-sm md:text-base font-medium text-white self-center'
    }
  ];

  const chunkedData = _.chunk(iconwithLabelData, 2);

  return (
    <div className='w-full flex justify-center'>
      <div className='flex flex-col md:flex-row items-start w-full max-w-7xl rounded-2xl p-6 bg-brand-gradient text-white relative'>
        <div className='flex flex-col items-start md:w-1/4'>
          <div className='flex items-center gap-3'>
            <Image
              alt='Partner Logo'
              className='rounded-full object-cover'
              height={isMobile ? 68 : 82}
              src={`${staticMediaStoreBaseURL}/icons/${icon}`}
              width={isMobile ? 50 : 60}
            />
            <div className='flex flex-col gap-0.5 md:gap-1 self-end'>
              <div className='text-xl md:text-2xl font-semibold'>
                {legalNameOfPartnerOrg}
              </div>
              <div className='text-base text-sm md:text-lg text-white/90'>
                {pocName}
              </div>
            </div>
          </div>
          <span className='inline-flex items-center gap-0.5 md:gap-1 bg-black px-3 py-1 rounded-full mt-4'>
            <Image
              alt='Star'
              className='w-3 h-3 md:w-4 md:h-4'
              height={16}
              src={`${staticMediaStoreBaseURL}/icons/${starIcon}`}
              width={16}
            />
            <div className={`text-xs md:text-sm ${valueStyle}`}>
              {`${label} partner`}
            </div>
          </span>
        </div>

        <div className='flex flex-col md:flex-row md:border-l-2 md:border-white/80 md:self-center gap-2 md:gap-1 mt-2 md:mt-0'>
          {chunkedData.map((chunkedColumn, index) => (
            <div
              key={index}
              className='flex flex-col gap-2 md:gap-1 md:px-10 md:border-l-2 md:border-white/80 first:md:border-l-0'
            >
              {chunkedColumn.map((iconWithLabelItem, idx) => (
                <IconWithLabel
                  key={idx}
                  {...{
                    ...iconWithLabelItem,
                    imgHeight: isMobile ? 24 : 28,
                    imgWidth: isMobile ? 24 : 28
                  }}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProfileHeaderOrganism;
